/**
 * EmptyChannelGrid — visto quando registry está vazio (não deveria
 * acontecer em produção, mas existe como fallback).
 */

import React from 'react';
import { IconPlug } from '@tabler/icons-react';

const EmptyChannelGrid = () => (
  <div
    style={{
      padding: '48px 24px',
      textAlign: 'center',
      color: '#9ca3af',
    }}
  >
    <IconPlug size={48} style={{ marginBottom: 12 }} />
    <p style={{ fontSize: 14 }}>Nenhum canal disponível ainda.</p>
  </div>
);

export default EmptyChannelGrid;
